import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rightsnap",
  "use": "icon-rightsnap-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-rightsnap\">\r\n<path d=\"M819.2 102.4l51.2 0 0 819.2-51.2 0 0-819.2ZM358.4 204.8l409.6 0 0 256-409.6 0 0-256ZM716.8 563.2l0 204.8L204.8 768l0-204.8L716.8 563.2M768 512 153.6 512l0 307.2 614.4 0L768 512 768 512z\" p-id=\"1976\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol